// components/ContactDetails.js
import React from 'react';
import SearchableCustomerSelect from '../../Common/SearchableCustomerSelect ';

const ContactDetails = ({
    formData,
    errors,
    handleInputChange,
    updateContactDetails
}) => {
    return (
        <>
            <div className="mb-3 col-lg-4 col-md-6">
                <label className="form-label">Select Customer</label>
                <div className={`form-group ${errors.customerId ? 'is-invalid' : ''}`}>
                    <SearchableCustomerSelect
                        onSelect={(selectedOption) => {
                            const customerId = selectedOption?.value || null;
                            handleInputChange('customerId', customerId);
                            updateContactDetails(customerId);
                        }}
                        value={formData.customerId}
                        placeholder="Search and select customer..."
                        controlled={true}
                    />
                    {errors.customerId && (
                        <div className="invalid-feedback d-block">{errors.customerId}</div>
                    )}
                </div>
            </div>
        </>
    );
};

export default ContactDetails;
